import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { persistor } from './store';
import './i18n'; 

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const render = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// プリレンダー済みの HTML を表示したまま、言語設定などの復元が終わってから描画する
// （PersistGate の待機中に一瞬空白になるのを防ぐ）
if (persistor.getState().bootstrapped) {
  render();
} else {
  const unsubscribe = persistor.subscribe(() => {
    if (persistor.getState().bootstrapped) {
      unsubscribe();
      render();
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
